export { default as studentGuideApi } from './works/StudentGuide'
export { default as monographyApi } from './works/Monography'
export { default as prePrintApi } from './works/PrePrint'
export { default as foreignCitationApi } from './works/ForeignCitation'
export { default as dissertationApi } from './works/Dissertation'
export { default as performanceApi } from './works/Performance'
export { default as peerReviewedPublicationApi } from './works/PeerReviewedPublication'
export { default as contestApi } from './works/Contest'
export { default as grantApi } from './works/Grant'
export { default as incalculationApi } from './works/Incalculation'
export { default as educationalPublicationApi } from './works/EducationalPublication'
export { default as nirAccomplishmentApi } from './works/NirAccomplishment'
export { default as publicOrganizationParticipationApi } from './works/PublicOrganizationParticipation'
export { default as publicationApi } from './works/Publication'
export { default as overseasEventApi } from './works/OverseasEvent'
export { default as cooperationInformationApi } from './works/CooperationInformation'
export { default as stateAwardApi } from './works/StateAward'
export { default as nirCompensationAgreementApi } from './works/NirCompensationAgreement'
export { default as winningScientificCompetitionApi } from './works/WinningScientificCompetition'
export { default as scientificPracticalEventApi } from './works/ScientificPracticalEvent'

export { default as employeePositionApi } from './directories/EmployeePosition'
export { default as employeeApi } from './directories/Employee'
export { default as statusApi } from './directories/Status'
export { default as forbiddenPeriodApi } from './directories/ForbiddenPeriod'
export { default as activityApi } from './directories/Activity'
export { default as bibliographyApi } from './directories/Bibliography'
export { default as publishingHouseApi } from './directories/PublishingHouse'
export { default as scienceStepApi } from './directories/ScienceStep'
export { default as dissertationDegreeApi } from './directories/DissertationDegree'
export { default as stateApi } from './directories/State'
export { default as protectionPlaceApi } from './directories/ProtectionPlace'
export { default as eventTypeApi } from './directories/EventType'
export { default as eventFormatApi } from './directories/EventFormat'
export { default as participantQuantityApi } from './directories/ParticipantQuantity'
export { default as performanceTypeApi } from './directories/PerformanceType'
export { default as vACApi } from './directories/VAC'
export { default as guideTypeApi } from './directories/GuideType'
export { default as nirTypeApi } from './directories/NirType'
export { default as inculcationLevelApi } from './directories/InculcationLevel'
export { default as specialityApi } from './directories/Speciality'
export { default as councilNameApi } from './directories/CouncilName'
export { default as positionApi } from './directories/Position'
export { default as dutyApi } from './directories/Duty'
export { default as salaryRateApi } from './directories/SalaryRate'
export { default as yearApi } from './directories/Year'
export { default as workTypeApi } from './directories/WorkType'
export { default as personTitleApi } from './directories/PersonTitle'
export { default as departmentApi } from './directories/Department'
export { default as facultyApi } from './directories/Faculty'
export { default as academicDegreeApi } from './directories/AcademicDegree'
export { default as periodApi } from './directories/Period'
export { default as magazineApi } from './directories/Magazine'
export { default as publicationFormApi } from './directories/PublicationForm'
export { default as cooperationTypeApi } from './directories/CooperationType'
export { default as educationalPublicationTypeApi } from './directories/EducationalPublicationType'
export { default as foreignOrganizationApi } from './directories/ForeignOrganization'
export { default as highschoolApi } from './directories/Highschool'
export { default as interactionTypeApi } from './directories/InteractionType'
export { default as organizationApi } from './directories/Organization'
export { default as participationKindApi } from './directories/ParticipationKind'
export { default as participationStatusApi } from './directories/ParticipationStatus'
export { default as scientistNameApi } from './directories/ScientistName'
export { default as scientDepartmentApi } from './directories/ScientDepartment'
export { default as fundingRecipientApi } from './directories/FundingRecipient'
export { default as nirLevelApi } from './directories/NirLevel'
export { default as contestResultApi } from './directories/ContestResult'
export { default as countryApi } from './directories/Country'
export { default as catalogApi } from './directories/Catalog'
export { default as whiteListLevelApi } from './directories/WhiteListLevel'
export { default as filetypeApi } from './directories/FileType'
export { default as rewardApi } from './directories/Reward'
export { default as quarterApi } from './directories/Quarter'
export { default as editorialBoardRoleApi } from './directories/EditorialBoardRole'

export { default as reportApi } from './Report'
export { default as authorWorkApi } from './AuthorWork'
export { default as commonWorkApi } from './CommonWork'
export { default as bibliographyWorkApi } from './BibliographyWork'
export { default as efficiencyMetricApi } from './EfficiencyMetric'
export { default as councilMemberApi } from './CouncilMember'
export { default as oppositionApi } from './Opposition'
export { default as journalEditorialBoardApi } from './JournalEditorialBoard'

export { default as authApi } from './auth'
export { default as fileApi } from './File'
export { default as xlsxApi } from './xlsx'
export { default as printApi } from './print'
